import type { ShiptimeShipmentResponse } from '@shipium-corp/shipium-ts-types';
import type {
  RateCalculationTestResponse,
  RateCalculationTestRecord,
  RateCalculationTestRequest,
} from '../services/CarrierService/types';

export const adaptShipmentToCarrierSelectionResponse = (shipment: ShiptimeShipmentResponse) => {
  const rateCalculationTestRequest: RateCalculationTestRequest = {
    shipmentDestinationAddress: {
      ...shipment.destinationAddress,
      ...(shipment.destinationAddress?.company && {
        companyName: shipment.destinationAddress.company,
      }),
      ...(shipment.destinationAddress?.street1 && {
        address1: shipment.destinationAddress.street1,
      }),
      ...(shipment.destinationAddress?.street2 && {
        address2: shipment.destinationAddress.street2,
      }),
    },
    shipmentSourceAddress: {
      companyName: shipment.shipFromAddress.company,
      address1: shipment.shipFromAddress.street1,
      address2: shipment.shipFromAddress.street2,
      ...shipment.shipFromAddress,
    },
    desiredDeliveryDate: shipment?.desiredDeliveryDate,
    shipOption: shipment?.shipOption as any,
    deliverySignatureOption: shipment?.deliverySignatureOption,
    packagelinearDimensions: (shipment.packagingType?.linearDimensions as any) ?? {
      length: 0,
      width: 0,
      height: 0,
      linearUnit: 'in',
    },
    packagingMaterial: (shipment.packagingType?.packagingMaterial as any) ?? 'box',
    packageWeight: ((shipment.packagingType?.packagingWeight ?? shipment?.totalWeight) as any) ?? {
      weight: 0,
      weightUnit: 'lb',
    },
    orderItemQuantities: shipment.orderItemQuantities,
    partnerShipmentId: shipment.partnerShipmentId,
    shipmentEffectiveDate: shipment.shippedDateTime,
    saturdayDelivery: shipment?.saturdayDelivery,
  };

  const rateCalculationTestResponse: RateCalculationTestResponse = {
    shipiumShipmentId: shipment.shipiumShipmentId,
    partnerShipmentId: shipment.carrierSelection?.partnerShipmentId,
    ruleSetUrn: '', // Not available on megamethod
    ruleSetName: '', // Not available on megamethod
    carrierDecision: {
      carrier: shipment.carrierSelection?.carrier ?? '',
      status: shipment.carrierSelection?.status ?? '',
      carrierAccountId: shipment.carrierSelection?.carrierAccountId ?? '',
      partnerId: shipment.carrierSelection?.partnerId ?? '',
      serviceMethodUrn: shipment.carrierSelection?.serviceMethodUrn ?? '',
      serviceMethodName: shipment.carrierSelection?.serviceMethodName ?? '',
      carrierServiceName: shipment.carrierSelection?.serviceMethodName ?? '',
      carrierEstimatedPriceDetails: {
        totalCost: shipment.carrierSelection?.totalCost ?? 0,
        shippingCost: shipment.carrierSelection?.totalCost ?? 0,
        insuranceCost: 0,
        accessorials: 0,
        duty: 0,
        taxes: 0,
      },
      details: {
        calculatedRates: [],
        zonesByCarrier: {},
        serviceMethodsAfterFiltering: [],
        availableServiceMethods: [],
        requestParams: {
          currencyCode: shipment.carrierLabel?.carrierLabelCurrencyCode,
          shipmentShipDate: shipment.shippedDateTime,
          packagingType: (shipment.packagingType as any) ?? 'box',
        },
      },
    },
    carrierSelectionDateTime: shipment.carrierSelection?.carrierSelectionDateTime ?? new Date().toISOString(),
    shipmentShipDate: shipment.shippedDateTime,
    carrierSelectionId: shipment.carrierSelection?.carrierSelectionId ?? '',
    carrierSelectionExpiration: '', // Not available on megamethod
    carrierLabel: shipment.carrierLabel as any,
    labelVoided: shipment.carrierLabel?.status === 'voided',
    carrierSelection: shipment.carrierSelection as any,
    partnerThirdPartyBillingSetId: shipment.partnerThirdPartyBillingSetId,
    forceThirdPartyBilling: shipment.forceThirdPartyBilling,
    requestThirdPartyBillingSetId: shipment.requestThirdPartyBillingSetId,
  };

  const record: RateCalculationTestRecord = {
    request: rateCalculationTestRequest,
    response: rateCalculationTestResponse,
    rowIndex: 0,
  };

  return record;
};
